import PropType from 'prop-types'

const Title = ({ name }) => <h1 className="title">{ name }</h1>

Title.PropType = {
  name: PropType.string
}
export default Title
